// turnErrorSurface.js — FASE-11 E2-WS3. Superfície ÚNICA dos eventos de erro do
// turno no chat (extraída do onEvent do SessionWorkspace, que está no teto do
// ratchet dp-loc). Dois eventos:
//   • 'error'            — falha do loop: seta o banner + (billing → toast |
//                          resto → mensagem system no feed).
//   • 'stream_truncated' — o stream cloud COMEÇOU a emitir e caiu (runCloudTurn
//     devolveu o parcial marcado). NÃO é falha do turno (o parcial vale como
//     resposta, sem double-charge) mas o usuário PRECISA ver que pode estar
//     incompleto — antes disso o truncamento era 100% silencioso (achado #8/#24).
// 100% puro — todo efeito (banner, feed, toast) chega INJETADO; zero window/DOM
// (o arch:framework-free do loop/ trava isso). Unit-testável sem jsdom.

import { isBillingOrCreditsError } from '../codeAgentMode.js';

/**
 * @param {{ type: string, error?: string }} evt
 * @param {{ setError: (t: string) => void, pushMsg: (m: object) => unknown,
 *           emitToast?: (d: { kind: string, message: string }) => void }} io
 */
export function surfaceTurnEvent(evt, { setError, pushMsg, emitToast }) {
  if (evt.type === 'stream_truncated') {
    pushMsg({
      role: 'system',
      content: `⚠️ Stream interrompido — a resposta pode estar incompleta (${evt.error || 'conexão caiu'}).`,
    });
    return;
  }
  const errText = evt.error || 'Erro no agent loop';
  setError(errText);
  // Billing/limit: terminalNotice no fim do run mostra UMA mensagem — evita spam.
  if (isBillingOrCreditsError(errText)) {
    emitToast?.({ kind: 'error', message: 'OpenRouter: limite ou créditos — veja a mensagem no chat.' });
  } else {
    pushMsg({ role: 'system', content: `⚠️ ${errText}` });
  }
}
